import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useViewerIsSuperAdmin } from "@/lib/rights/use-viewer-is-baback-team";
import { PiiLookupView } from "@/shared-screens/pii-lookup/pii-lookup-view";
import { Navigate } from "react-router-dom";

/** Returns: the PII vault debugging screen of the current shop. */
export default function PiiLookupPage() {
  const { data: shop } = useCurrentShopSuspense();
  const isSuperAdmin = useViewerIsSuperAdmin();

  if (!isSuperAdmin) {
    return <Navigate to={`/shops/${shop.id}`} replace />;
  }

  return (
    <div className="p-6 space-y-6 max-w-5xl">
      <h1 className="text-2xl font-semibold">Données personnelles</h1>
      <PiiLookupView shopId={shop.id} shopName={shop.name} />
    </div>
  );
}
